// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/_layout.tsx": { enumerable: true, get() { return require("/app/app/(auth)/_layout.tsx"); } },
  "./(auth)/callback.tsx": { enumerable: true, get() { return require("/app/app/(auth)/callback.tsx"); } },
  "./(auth)/login.tsx": { enumerable: true, get() { return require("/app/app/(auth)/login.tsx"); } },
  "./(auth)/what-matters.tsx": { enumerable: true, get() { return require("/app/app/(auth)/what-matters.tsx"); } },
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/chat.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/chat.tsx"); } },
  "./(tabs)/inbox.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/inbox.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/index.tsx"); } },
  "./(tabs)/quotes/_layout.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/quotes/_layout.tsx"); } },
  "./(tabs)/quotes/index.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/quotes/index.tsx"); } },
  "./(tabs)/quotes/market.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/quotes/market.tsx"); } },
  "./(tabs)/regninger/_layout.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/regninger/_layout.tsx"); } },
  "./(tabs)/regninger/index.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/regninger/index.tsx"); } },
  "./(tabs)/settings.tsx": { enumerable: true, get() { return require("/app/app/(tabs)/settings.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/app/app/_layout.tsx"); } },
  "./mitid/callback.tsx": { enumerable: true, get() { return require("/app/app/mitid/callback.tsx"); } },
  "./onboarding/index.tsx": { enumerable: true, get() { return require("/app/app/onboarding/index.tsx"); } },
  "./privatlivspolitik.tsx": { enumerable: true, get() { return require("/app/app/privatlivspolitik.tsx"); } },
  "./thread/[id].tsx": { enumerable: true, get() { return require("/app/app/thread/[id].tsx"); } },
  "./vilkaar.tsx": { enumerable: true, get() { return require("/app/app/vilkaar.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;